import { DynamicKey } from '@school/schemas/typeInterface'

export const createQueryString = (filter: { [key: string]: string }) => {
  const params = new URLSearchParams(filter)
  return params.toString()
}

export const trimmedValues = <T extends Record<string, any>>(values: T): T => {
  return Object.fromEntries(
    Object.entries(values).map(([key, value]) =>
      typeof value === 'string' ? [key, value.trim()] : [key, value],
    ),
  ) as T
}

export const modifyRportList = (reportList: DynamicKey[]) => {
  return reportList && reportList?.length
    ? reportList?.map((item: DynamicKey) => ({
        ...item,
        status:
          item?.user_status === true
            ? 'Active'
            : item?.user_status === false
              ? 'Inactive'
              : item?.status,
      }))
    : []
}
